import React, { Component } from "react";
// import cloud from "./images/cloud.png";
import profile from "./images/profile_pic.png";
import "./App.css";
import InternalLinks from "./internal_links";
import ExternalLinks from "./external_links";
import {isMobile} from "react-device-detect";
// import Snowfall from "react-snowfall";

class Main extends Component {

  render() {
    return (
        <div id="/"> 

          {/* <Snowfall 
            style={{zIndex: 1, position: "fixed"}}
            speed={[1.0, 2.5]}
            snowflakeCount={80}
            opacity={isMobile? 0.5 : 0.7} 
          /> */}

          {/* <img className="top-cloud" src={ cloud } alt={ "cloud-img" } /> */}
          <h1>
          I'm Gin Ee
          </h1>
          <img className="circular-img" src={ profile } alt={ "profile-img" } />

          <div className="typewriter"><h2><p>Data Scientist</p></h2></div>
          
          {/* <img className="middle-cloud" src={ cloud } alt={ "cloud-img" } /> */}
          {/* <img className="bottom-cloud" src={ cloud } alt={ "cloud-img" } /> */}

          <div style={{"margin":"30px 0px 30px"}}>
            <InternalLinks />
          </div>

          <div style={{"margin":"40px 0px 50px"}}>
            <ExternalLinks />

            <div>
              <p className="copyright" style={{"color":"#FFCE45"}}>© 2023 Leow Gin Ee</p>
            </div>

          </div>

        </div>
    );
  }

}

export default Main;